<template>
  <!--法人代表对外投资-->
  <TableView
    :columns="columns"
    :data="data"
    :pagination="false"
    :loading="loading"
    :bordered="bordered"
    :rowKey="rowKey"
  ></TableView>
</template>
<script>
import { TableView } from '@/lxfintech-fe-components'
export default {
  props: ['data'],
  components: { TableView },
  data() {
    return {
      rowKey: 'id',
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return index + 1
          },
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          key: 'enterpriseName',
        },
        {
          title: '企业类型',
          dataIndex: 'enterpriseType',
          key: 'enterpriseType',
        },
        {
          title: '企业状态',
          dataIndex: 'operateStatus',
          key: 'operateStatus',
        },
        {
          title: '注册资本（万元）',
          dataIndex: 'registeredCapital',
          key: 'registeredCapital',
        },
        {
          title: '职务',
          dataIndex: 'position',
          key: 'position',
        },
      ],
      loading: false,
      bordered: true,
    }
  },
  methods: {},
}
</script>
